<style src="./Login.scss" lang="scss" scoped></style>
<template lang="html">
  <section class="login">
    <transition name="present">
      <div class="login-form" v-if="showLoginForm">
        <div class="logo">
          <img src="static/logo/logo-397x140.png" alt="Sinkr Logo" />
        </div>

        <div class="info">
          <h4><strong>Bem vindo ao Sinkr</strong></h4>
          <h4>Faça o login para acessar o sistema</h4>
        </div>

        <div class="form-fields">
          <form v-on:submit.prevent="onSubmit">
            <textbox
              id="another"
              class="form-field"
              v-model="username"
              label="Usuário"
              placeholder="Informe o nome do usuário"
              autofocus
              :validation="{ group: 'login', required: true, min: 3 }"
            >
              <icon-user slot="icon" />
            </textbox>

            <password
              class="form-field"
              v-model="password"
              label="Senha"
              placeholder="Digite a senha"
              :validation="{ group: 'login', required: true, min: 3 }"
            >
              <icon-key slot="icon" />
            </password>

            <span class="" v-show="showLoginStatus">{{ loginStatus }}</span>

            <button
              class="btn-success margin-2em"
              :disabled="sumbitButtonState"
            >
              Entrar
            </button>

            <div class="footer margin-2em">
              <h6>Sinkr :: 2015 - 2026 :: v3.6.1</h6>
            </div>
          </form>
        </div>
      </div>
    </transition>
  </section>
</template>

<script>
import { Textbox, Password } from "@/components/primitives";
import { CheckGroupIsValid } from "@/components/primitives/validator/validator-helper/ValidatorHelper";
import { IconUser, IconKey } from "@/components/primitives/icons";

export default {
  name: "Login",
  components: {
    Password,
    Textbox,
    IconUser,
    IconKey
  },
  data() {
    return {
      username: "",
      password: "",
      submitDisabled: false,
      showLoginForm: false,
      showLoginStatus: false,
      loginStatus: null,
      sumbitButtonState: false
    };
  },
  watch: {
    username() {
      this.showLoginStatus = false;
    },
    password() {
      this.showLoginStatus = false;
    }
  },
  created() {
    const appExpired = this.$store.getters["Login/GET_EXPIRE_STATUS"];
    if (appExpired !== "PERMANENTLY") this.$router.replace("/welcome");
  },
  mounted() {
    this.showLoginForm = true;
  },
  methods: {
    async onSubmit() {
      try {
        const cmpIsValid = CheckGroupIsValid(this, "login");
        this.loginStatus = "";
        if (cmpIsValid) {
          this.sumbitButtonState = true;
          const loginInfo = {
            username: this.username,
            password: this.password
          };
          await this.$store.dispatch("Login/DO_LOGIN", loginInfo);
          await this.$store.dispatch("Distributors/LOAD_DEFAULT");
          this.$router.replace("/welcome");
        }
      } catch (error) {
        this.loginStatus = "Usuário ou senha incorretos";
        this.showLoginStatus = true;
      } finally {
        this.sumbitButtonState = false;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/view/login/Login.vue